import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface CheckboxProps extends FormlyFieldProps {
    formCheck?: 'default' | 'inline' | 'switch' | 'inline-switch' | 'nolabel';
    indeterminate?: boolean;
    hideRequiredMarker?: boolean;
}

@Component({
  standalone: false,
    selector: "formly-field-checkbox",
    templateUrl: "./checkbox.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldCheckbox extends FieldType<FieldTypeConfig<CheckboxProps>> {
    override defaultOptions = {
        props: {
            indeterminate: false,
            formCheck: 'default' as const,
            hideRequiredMarker: false,
        },
    };
}